export const ROOMS_QUERY_KEY = () => ["rooms"];
export const ROOM_QUERY_KEY = (roomId) => ["rooms", roomId];
export const ROOM_ITEMS_QUERY_KEY = (roomId) => ["rooms", roomId, "items"];
export const ROOM_ITEM_QUERY_KEY = (roomId, itemId) => [
  "rooms",
  roomId,
  "items",
  itemId,
];
